module.exports = __webpack_public_path__ + "img/bri.478fb5f1.png";